import React from 'react';
import Preloader from '../../../global/Preloader';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { DELETE_PARTNER_CLIENT_ACCOUNT } from '../../../../actions/delete';
import {Box, ButtonV2, Modal, Typography} from "@/elements";

const ModalDeleteAccount = ({ show, hideModal, id, name, query, getVariables }) => {
    const [setDeleteAccount, { loading }] = useMutation(DELETE_PARTNER_CLIENT_ACCOUNT);

    const onClickDelete = () => {
        setDeleteAccount({
            variables: {
                id,
            },
            refetchQueries: [{ query: query, variables: getVariables() }],
        })
            .then(() => toast.success('Success'))
            .catch(err => toast.error(err.message));
        hideModal();
    };

    if (loading) return <Preloader />;

    return (
        <Modal
            enableMaximize={false}
            width="400px"
            title={"Delete account"}
            toggle={() => hideModal()}
        >
            <Box>
                <Typography>
                    Are you sure that you want to delete the client’s account id {' '}
                    <b>
                        {name} (id {id})
                    </b>
                    ?
                </Typography>
            </Box>

            <Box direction="column" gap="16px" margin="8px 0">
                <Box width="100%" align="center" gap="16px" justify="right">
                    <ButtonV2 variant="greenSmoke" onClick={() => hideModal()}>
                        Cancel
                    </ButtonV2>
                    <ButtonV2 variant="primary" onClick={onClickDelete}>
                        Delete
                    </ButtonV2>
                </Box>
            </Box>
        </Modal>
    );
};

export default ModalDeleteAccount;
